module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_24.fd8dfd86.png";